import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MailingComment } from './types/mailing-comment.type';

/**
 * Inserts a comment for a specific mailing.
 *
 * Sends a POST request to the mailing comment insertion endpoint with the provided comment data.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param data - The mailing comment data to be inserted.
 * @returns A promise that resolves to an `OperationResultWithData<number>` containing the result of the operation.
 * @throws Throws an error if the request fails.
 */
export const insertMailingComment = async (instance: KyInstance, data: MailingComment) => {
  try {
    return await instance
      .post<OperationResultWithData<number>>(
        formatString(Uri.mailing.insertMailingComment, data.mailingId.toString()),
        {
          json: data,
        }
      )
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
